import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationsService } from 'app/internal/notifications/shared/services/notifications.service';
import { UserSettingsActions } from '../actions/user-settings.actions';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class UserSettingsEffects {

  constructor(
    private actions$: Actions,
    private notificationsService: NotificationsService,
    private toastr: ToastrService,
  ) { }

  loadUserNotificationPreferences$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserSettingsActions.loadUserNotificationPreferences),
      mergeMap(() =>
        this.notificationsService.getUserNotificationsPreferences()
          .pipe(
            map((responsePayload) => UserSettingsActions.loadUserNotificationPreferencesSuccess({ data: responsePayload })),
            catchError(error => of(UserSettingsActions.loadUserNotificationPreferencesFailure({ error }))))
      )
    );
  });

  updateUserNotificationPreferences$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserSettingsActions.updateUserNotificationPreferences),
      mergeMap((payload) =>
        this.notificationsService.updateUserNotificationsPreferences(payload.data)
          .pipe(
            map(() => UserSettingsActions.updateUserNotificationPreferencesSuccess()),
            catchError(error => of(UserSettingsActions.updateUserNotificationPreferencesFailure({ error }))))
      )
    );
  });

  updateUserNotificationPreferencesSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserSettingsActions.updateUserNotificationPreferencesSuccess),
      mergeMap(() => {
        this.toastr.success('User Preferences updated.');
        // Reload preferences after successful update to ensure all tabs reflect the changes
        return of(UserSettingsActions.loadUserNotificationPreferences());
      }),
    );
  });
}
